import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src2453106473/src/client-hcap/components/ui/hcap-study-locations-diagram.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src2453106473/src/client-hcap/components/ui/metic-section.tsx");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src2453106473/src/client-hcap/node_modules/next/dist/client/link.js");
